import { Component, Input, Output, EventEmitter } from "@angular/core";
import { DatasetType, Dataset, Folder } from "4d-mapper";
import { ArrayStore, Store } from 'vasat/dist/src/veflux'
import { TreeEvent, TreeNode, TreeNodeBuilder } from "./tree-events";
import { FileEvent, FileDataService } from "../file-data.service";
import { Subscription } from "rxjs";

@Component({
    selector:'file-picker',
    templateUrl:'./file_picker.component.html',
    styleUrls:['./file_picker.component.scss']
})
export class FilePickerComponent{
 

    @Input()
    mode:'files'|'folders' = 'files'

    @Input()
    filterTypes:DatasetType[]

    @Input()
    startInFolder:Folder

    @Output()
    onSelectedFiles = new EventEmitter<Dataset[]>()

    @Output()
    onSelectedFolders = new EventEmitter<Folder>()

    @Output()
    onCancel = new EventEmitter<any>()

    displayedFilesStore = new ArrayStore(FileEvent)
    selectedFilesStore = new ArrayStore(FileEvent,[],this.displayedFilesStore)
    selectedFolderStore = new Store(TreeEvent)
    
    canPick:boolean = false
   
    files:Dataset[] = []
    folder:Folder
    
    folderRoot = new ArrayStore(TreeEvent)

    private _subs:Subscription[] = []

    constructor(private fileManager:FileDataService, private builder:TreeNodeBuilder){}    

    ngOnInit(){
        this.fileManager.onTeamReady().subscribe(_ => {
            if(this.startInFolder){
                this.folderRoot.values = [this.builder.fromFolder(this.startInFolder)]
            }
            else{
                this.folderRoot.values = [this.builder.fromAccount(this.fileManager.team.value)]
            }
        })
        this._subs.push(this.selectedFilesStore.state.subscribe(f => {
            this.files = f
            this.checkPick()
        }))

        this._subs.push(this.selectedFolderStore.state.subscribe(s => 
            this.folder = s.ref instanceof Folder ? s.ref : null
        ))
    }

    ngOnDestroy(){
        this._subs.forEach(s => s.unsubscribe())
    }

    pick(){
        if(this.mode == 'files'){
            this.onSelectedFiles.emit(this.selectedFilesStore.values)
        }
        else{
            this.onSelectedFolders.emit(<Folder>this.selectedFolderStore.value.ref)
        }
    }
    cnx(){
        this.onCancel.emit(true)
    }
    private checkPick(){
        if(this.mode == 'files'){
            this.canPick = !!this.files.length
        }
        else{
            this.canPick = !!this.folder
        }
    }
}